import { render, staticRenderFns } from "./CasesCIDHub.vue?vue&type=template&id=b6506af6&"
import script from "./CasesCIDHub.vue?vue&type=script&lang=js&"
export * from "./CasesCIDHub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports